import styled from 'styled-components'

import { FlexBox } from '../../../components/Base/FlexBox'
import { InfoTooltip } from '../../../components/InfoTooltip/InfoTooltip'
import { Text } from '../../../components/Text/Text'
import { TOOLTIP_DIRECTIONS } from '../../../components/Tooltip/constants'
import { SafetyScoreRange } from '../../../models/compliance'
import { cyan, darkGray, midGray, white } from '../../../theme/colors'

interface ScoreIndicatorProps {
  title: string
  ranges: SafetyScoreRange[]
}

export function SafetyInfoTooltip({ title, ranges }: ScoreIndicatorProps) {
  return (
    <StyledInfoTooltipWrapper direction={TOOLTIP_DIRECTIONS.DOWN_START}>
      <FlexBox isColumn gap="20px">
        <Text variant="paragraph1" fontColor={darkGray}>
          {title}
        </Text>
        {ranges?.map((range) => (
          <FlexBox key={range.label} alignItems="center" gap="16px">
            <ScoreIndicator $backgroundColor={range.color} />
            <Text variant="label2" fontColor={midGray} fontWeight={400}>
              {range.label} ({range.min > 0 ? range.min : 0}-{range.max})
            </Text>
          </FlexBox>
        ))}
      </FlexBox>
    </StyledInfoTooltipWrapper>
  )
}

export const StyledInfoTooltipWrapper = styled(InfoTooltip)`
  .react-tooltip-lite {
    max-width: 410px !important;
    width: unset !important;
    border: 1px solid ${cyan} !important;
    border-radius: 6px !important;
    box-shadow: none !important;
  }

  .tooltip-content-container {
    padding: 24px 35px 24px 24px;
    background: ${white};
    width: unset !important;
  }

  svg {
    font-size: 20px !important;
    margin-top: -2px;
  }
`
export const ScoreIndicator = styled.div<{ $backgroundColor?: string | null }>`
  margin-top: -3px;
  width: 10px;
  height: 10px;
  border-radius: 2px;
  background-color: ${({ $backgroundColor }) => $backgroundColor ?? white};
`
